export const MENU_QUERY_KEY = 'menu-query-key';
